import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { EmailValidationRegEx } from '../constants/validation-regex';

export const emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  return EmailValidationRegEx.test(control.value) ? null : { email: true };
};
